"use client";

import React from "react";
import { Mail, MapPin, RefreshCw } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PolicyUpdatesAndContact() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="policyupdatesandcontact" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6 max-w-5xl">
        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-2 gap-8 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <Card className="h-full border-border shadow-sm hover:shadow-md transition-shadow duration-300">
            <CardHeader className="pb-4">
              <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center mb-4">
                <RefreshCw className="w-6 h-6 text-primary" />
              </div>
              <CardTitle className="text-2xl font-bold text-[#352467] font-sans">
                Changes to This Privacy Policy
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-muted-foreground leading-relaxed font-sans">
                We may update this Privacy Policy from time to time. Any changes
                will be posted on our website and will take effect immediately
                upon publication. We encourage you to review this policy
                periodically to stay informed about how we are protecting your
                information.
              </p>
            </CardContent>
          </Card>

          {}
          <Card className="h-full border-border shadow-sm hover:shadow-md transition-shadow duration-300">
            <CardHeader className="pb-4">
              <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center mb-4">
                <Mail className="w-6 h-6 text-primary" />
              </div>
              <CardTitle className="text-2xl font-bold text-[#352467] font-sans">
                Contact Us
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-6">
              <p className="text-muted-foreground leading-relaxed font-sans">
                If you have any questions regarding this Privacy Policy or our
                handling of your personal data, please contact us using the
                details below:
              </p>

              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <MapPin className="w-5 h-5 text-primary shrink-0 mt-0.5" />
                  <div className="font-sans">
                    <p className="font-semibold text-foreground">
                      Coastline Air Conditioning Services Ltd
                    </p>
                    <p className="text-muted-foreground">Merrydown</p>
                    <p className="text-muted-foreground">Kingston Lane</p>
                    <p className="text-muted-foreground">East Preston</p>
                    <p className="text-muted-foreground">BN16 1RP</p>
                  </div>
                </div>

                <div className="flex items-center gap-3">
                  <Mail className="w-5 h-5 text-primary shrink-0" />
                  <Link to="mailto:info@coastline-services.co.uk" className="text-primary hover:underline font-medium font-sans">
                    info@coastline-services.co.uk
                  </Link>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}